/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    AppellationDTO,
    PageWineProductDto,
    PageWineProductInstanceDto,
    WineProductDto,
    WineProductInstanceDto,
    WineProductInstanceNameDto,
    WineProductInstanceUnitOfMeasureDto,
    WineProductInstanceUpdateDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class WineProductControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        createWineProduct(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: WineProductDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        createWineProductInstance(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: WineProductInstanceDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        deleteWineProduct(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        deleteWineProductInstance(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        getAppellations(
                
                queryParams: {
                    region: string
                }
    ): Observable<Array<AppellationDTO>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/appellations`;

            return this._httpClient.get<Array<AppellationDTO>>(url, requestOptions);
    }


        getUnallocatedVolume(
                    id: number
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/${id}/unallocatedVolume`;

            return this._httpClient.get<number>(url, requestOptions);
    }


        getUnitsOfMeasure(
    ): Observable<Array<WineProductInstanceUnitOfMeasureDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/unitsOfMeasure`;

            return this._httpClient.get<Array<WineProductInstanceUnitOfMeasureDto>>(url, requestOptions);
    }


        getWineProduct(
                    id: number
    ): Observable<WineProductDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates/${id}`;

            return this._httpClient.get<WineProductDto>(url, requestOptions);
    }


        getWineProducts(
                
                queryParams: {
                    wineryId?: number,
                    productNameLike?: string,
                    userLegalEntityId?: number
                }
    ): Observable<Array<WineProductDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates`;

            return this._httpClient.get<Array<WineProductDto>>(url, requestOptions);
    }


        getWineProductsInstance(
                    id: number
    ): Observable<WineProductInstanceDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/${id}`;

            return this._httpClient.get<WineProductInstanceDto>(url, requestOptions);
    }


        getWineProductsInstanceName(
                    id: number
    ): Observable<WineProductInstanceNameDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/${id}/name`;

            return this._httpClient.get<WineProductInstanceNameDto>(url, requestOptions);
    }


        getWineProductsInstancePage(
                
                queryParams: {
                    wineryId?: number,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWineProductInstanceDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/page`;

            return this._httpClient.get<PageWineProductInstanceDto>(url, requestOptions);
    }


        getWineProductsInstances(
                
                queryParams: {
                    wineryId?: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<WineProductInstanceDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances`;

            return this._httpClient.get<Array<WineProductInstanceDto>>(url, requestOptions);
    }


        getWineProductsPage(
                
                queryParams: {
                    productNameLike?: string,
                    wineryId?: number,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWineProductDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates/page`;

            return this._httpClient.get<PageWineProductDto>(url, requestOptions);
    }


        isWineProductEditable(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates/${id}/editable`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        isWineProductInstanceEditable(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instance/${id}/editable`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        prepareDefaultWineProductInstance(
                
                queryParams: {
                    wineProductId: number,
                    userLegalEntityId?: number
                }
    ): Observable<WineProductInstanceDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances/default`;

            return this._httpClient.get<WineProductInstanceDto>(url, requestOptions);
    }


        updateWineProduct(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: WineProductDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/templates`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        updateWineProductInstance(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: WineProductInstanceUpdateDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/wineproduct/instances`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


}

